import { createContext, useContext } from 'react';

import { MessageSubmissionContextValue } from './MessageSubmissionContextProvider.types.ts';

export const MessageSubmissionContext = createContext<MessageSubmissionContextValue | null>(null);

export const useMessageSubmissionContext = () => {
  const context = useContext(MessageSubmissionContext);
  if (context == null) {
    throw new Error('useMessageSubmissionContext must be used within a MessageSubmissionContextProvider');
  }
  return context;
};
